export default __webpack_public_path__ + "transfix-maps/icons/P4.f12fdfba068b498cff8a775bfb2915dc.png";